export const tableColumnList = [
  {
    field: 'kpiName', // 1
    title: '指标类型',
    width: '200',
    editRender: {
      name: 'kpiName',
    },
  },
  {
    field: 'completeAmt',
    title: '完成额（本月费用、金额、毛利）',
    width: '250',
    editRender: { name: 'completeAmt' },
  },

  {
    field: 'targetAmt',
    title: '预算',
    width: '160',
    editRender: {
      name: 'targetAmt',
    },
  },
  {
    field: 'amortizedCost',
    title: '已摊销成本',
    width: '160',
    editRender: {
      name: 'amortizedCost',
    },
  },
  {
    field: 'remainCost',
    title: '剩余截留成本',
    width: '160',
    editRender: {
      name: 'remainCost',
    },
  },
  {
    field: 'remark',
    title: '备注',
    width: '200',
    editRender: { name: 'remark' },
  },
];

export const tableColumnList1 = [
  {
    field: 'kpiName', // 1
    title: '指标类型',
    width: '200',
    editRender: {
      name: 'kpiName',
    },
  },
  {
    field: 'completeAmt',
    title: '完成额、本月费用、金额、毛利、目标值(万元)',
    width: '300',
    editRender: { name: 'completeAmt' },
  },

  {
    field: 'targetAmt',
    title: '营收、利润预算(万元)',
    width: '250',
    editRender: {
      name: 'targetAmt',
    },
  },
  {
    field: 'remark',
    title: '备注',
    width: '300',
    editRender: { name: 'remark' },
  },
];

export const tableColumnList2 = [
  {
    field: 'kpiName', // 1
    title: '指标类型',
    width: '200',
    editRender: {
      name: 'kpiName',
    },
  },
  {
    field: 'amortizedCost',
    title: '已摊销成本(万元)',
    width: '250',
    editRender: {
      name: 'amortizedCost',
    },
  },
  {
    field: 'remainCost',
    title: '剩余截留成本(万元)',
    width: '200',
    editRender: {
      name: 'remainCost',
    },
  },
  {
    field: 'remark',
    title: '备注',
    width: '300',
    editRender: { name: 'remark' },
  },
];

export const tableRules = {
  // kpiName: [{ required: true, message: '指标类型不能为空' }],
  // completeAmt: [{ required: true, message: '完成额不能为空' }],
  // targetAmt: [{ required: true, message: '预算不能为空' }],
  // amortizedCost: [{ required: true, message: '已摊销成本不能为空' }],
  // remainCost: [{ required: true, message: '剩余截留成本不能为空' }],
};
